import ErrorView from '@/components/shared/ErrorView';
import ApplicationSelector from '@/components/simulator/ApplicationSelector';
import LaunchWizard from '@/components/simulator/LaunchWizard';

const InstanceView = () =>
  import(/* webpackChunkName: "InstaceView" */ '@/components/simulator/InstanceView');

export default [
  {
    path: '',
    name: 'DefaultView',
    redirect: { name: 'ApplicationSelector' },
  },
  {
    path: '/404',
    name: '404View',
    component: ErrorView,
  },
  {
    path: '/applications',
    name: 'ApplicationSelector',
    component: ApplicationSelector,
  },
  {
    path: '/instances/:id',
    name: 'InstanceView',
    component: InstanceView,
    props: true,
  },
  {
    path: '/wizard',
    name: 'LaunchWizard',
    component: LaunchWizard,
    meta: { labelKey: 'nav.launchWizard' },
  },
];
